<form class="loan-pipeline-task-dialog-wrapper" (submit)="navigateToPost($event)">
	<p class="dialog-title">{{ data.notificationType === 'birthday' ? 'Happy Birthday! &#127881;' : 'You’ve been recognized!' }}</p>
	<mat-dialog-content class="dialog-content-wrapper" [style.--recognition-color]="data.recognitionColorCode">
		<div class="recognition-tag">
			@if (data.recognitionIconCode === 'trb_logo') {
				<img class="icon" src="../../../../../assets/images/Trb-latest-svg/trb_logo.svg" />
			} @else {
				<mat-icon class="material-icons-outlined icon">{{ data.recognitionIconCode }}</mat-icon>
			}
		</div>
		<p class="notification-text">
			@if (data.notificationType === 'birthday') {
				Wishing you a fantastic day and a year ahead filled with success, happiness, and good health. We're grateful to have you on the team.
			}

			@if (data.notificationType === 'recognition') {
				Congratulations <b>{{ data.receivingInternalUserName }}</b
				>, you've been recognized by <b>{{ data.sendingInternalUserName }}</b> for <b class="recognition-type">{{ data.recognitionType }}</b
				>!
			}
		</p>
		@if (data.amount) {
			<p class="notification-text">
				<b>{{ data.sendingInternalUserName }}</b> has rewarded you with <b class="goldcoin-amount">{{ data.amount * data.conversionRate }} Goldcoins</b>
			</p>
		}
	</mat-dialog-content>
	<mat-dialog-actions class="dialog-actions-wrapper">
		<app-button variant="text" category="action" type="button" [onClick]="onClose">Close</app-button>
		<div class="flex-wrapper">
			<app-button variant="outlined" category="primary" type="button" [onClick]="navigateToRewards">Go to My Rewards</app-button>
			@if (data.notificationType === 'recognition') {
				<app-button variant="contained" category="primary" type="submit" [onClick]="navigateToPost">Go to Post</app-button>
			}
		</div>
	</mat-dialog-actions>
</form>
